import { FormattedMessage } from 'react-intl';

import { ColorPropertyInput } from '../color-property-input';
import { messages } from './messages';

import type { BaseWidget, Color, WidgetPropertyInput, WidgetPropertyDefinition } from '../../../config';

type WidgetWithFill = BaseWidget & { fill?: Color };

const FillColorPicker = ({ widget, updateWidget, ...rest }: WidgetPropertyInput<WidgetWithFill>) => {
  return <ColorPropertyInput updateWidget={(value) => updateWidget({ fill: value })} value={widget.fill} {...rest} />;
};

export const FillColorProperty: WidgetPropertyDefinition<WidgetWithFill> = {
  id: 'fill-color',
  label: <FormattedMessage {...messages.label} />,
  Component: FillColorPicker,
};
